import CryptoJS from 'crypto-js'

export const getStatusChipStyles = (status) => {
  switch (status) {
    case 'Complete':
      return { bgcolor: '#D8F7F4', color: '#259A92', border: '1px solid #259A92', fontWeight: 'bold' }
    case 'In Progress':
      return { bgcolor: '#E7EAFC', color: '#2F3DA3', border: '1px solid #2F3DA3', fontWeight: 'bold' }
    default:
      return { bgcolor: '#E8EBF1', color: '#465464', border: '1px solid #465464', fontWeight: 'bold' }
  }
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1
  }
  if (b[orderBy] > a[orderBy]) {
    return 1
  }
  return 0
}

export function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy)
}

export const listOfAppStatuses = {
  1: 'Policy Submitted',
  2: 'Declined',
  3: 'MIB Pending',
  4: 'KO Declined',
  5: 'ID Check Failed',
  6: 'Applicant Not Eligible',
  7: 'Application Expired',
  10: 'RUW',
  null: 'Incomplete',
  // 0: 'Invalid request',
  // 1: 'Approved',
  // 2: 'Declined',
  // 3: 'MIB Pending',
  // 4: 'Declined due to UW questions',
  // 5: 'Incomplete',
  // 6: '3rd party insufficient',
  // 7: 'ID check failed',
  // 9: 'System issues',
  // 10: 'Disqualified',
  // 99: 'Decision not ready, call back',
}

export const statusCompletions = (num) => {
  num = String(num)
  switch (num) {
    case '1':
      return 'Submitted'
    case '2':
    case '4':
    case '6':
    case '7':
      return 'Completed'
    case '3':
    case '5':
    case 'null':
    case '10':
      return 'In Progress'
    default:
      return 'Not Started'
  }
}

export const listOfAppStatusesV2 = {
  1: 'Illustration generated',
  2: 'Pending interview(s)',
  3: 'Pending Government ID',
  4: 'Pending ID review – Foresters',
  5: 'RUW',
  6: 'Pending payment details',
  7: 'Pending AML review',
  8: 'Pending signature(s)',
  9: 'Pending agent validation',
  10: 'Pending agent certification',
  11: 'Pending 90-day change',
  12: 'NPW',
  121: 'NPW - Offer expired',
  122: 'NPW - Timeout',
  123: 'NPW - Agent Liscensing',
  124: 'NPW - Payment failure',
  125: 'NPW - Ineligible',
  126: 'NPW - AIF',
  127: 'NPW - Ineligible (App Questions)',
  128: 'NPW - MIB',
  13: 'Decline',
  14: 'Pending Issue',
  15: 'Issued',
  0: '',
}

export const statusCompletionsV2 = (num) => {
  num = String(num)
  switch (num) {
    case '1':
    case '2':
    case '3':
    case '4':
    case '5':
    case '6':
    case '7':
    case '8':
    case '9':
    case '10':
    case '11':
      return 'In Progress'
    case '12':
    case '13':
    case '14':
    case '15':
    case '121':
    case '122':
    case '123':
    case '124':
    case '125':
    case '126':
    case '127':
      return 'Complete'
    default:
      return 'In Progress'
  }
}

export const statusCompletionsV3 = (status) => {
  if (!status) {
    return 'Not Started'
  }
  if (status?.toLowerCase().includes('npw')) {
    console.log('ITS TRUE!!!!')
    return 'Complete'
  }
  switch (status) {
    case 'Not Proceeded With':
    case 'NPW-Not ELigible':
    case 'MIB Pend':
    case 'Issued':
    case 'Lapsed':
    case 'Declined':
      return 'Complete'
    case 'Interview in Progress':
    case 'Awaiting Additional Details':
    case 'Pending Decision':
    case 'Pending Consent':
    case 'RUW':
    case 'Offer approved-pending payment details':
    case 'Pending signature(s)':
    case 'Pending producer certification':
    case 'Pending Issue':
      return 'In Progress'
    default:
      return 'Not Started'
  }
}

export const listOfProducts = {
  8113: 'Accidental Death',
  8118: 'Quility Secure Future Select',
  8140: 'Quility Level Term',
  8142: 'Quility Level Term Return of Premium',
  81401: 'Quility Level Term',
  4127: 'Foresters Live Well Plus',
  511801: 'NewBridge Final Expense',
}

export const decryptLink = (url) => {
  try {
    url = url && url.replace(/[\r\n]/g, '')
    var iv = CryptoJS.enc.Utf8.parse('1234567812345678')
    var key = CryptoJS.enc.Utf8.parse('1234567812345678')

    var decrypted = CryptoJS.AES.decrypt(url, key, {
      iv: iv,
      padding: CryptoJS.pad.Pkcs7,
    })

    const newUrl = decrypted.toString(CryptoJS.enc.Utf8)

    console.log('final url: ', newUrl)
    return newUrl
  } catch (error) {
    console.log('error while decrypting')
    return null
  }
}
